module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "newTopic"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    话题管理 > 新增\n    "), _c('el-button', {
    staticClass: "right_f",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitCreateTopic
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('div', {
    staticClass: "topicDetail"
  }, [_c('el-form', {
    ref: "topicForm",
    staticClass: "topic-form",
    attrs: {
      "model": _vm.topicForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "话题头像",
      "prop": "coverImage"
    }
  }, [_c('SUpload', {
    attrs: {
      "value": [_vm.topicForm.coverImage],
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false,
      "on-success": _vm.handleCoverUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("\n          建议尺寸73*73，大小≤50KB，优先webp次选png\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详情页图片"
    }
  }, [_c('SUpload', {
    attrs: {
      "value": [_vm.topicForm.detailImage],
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "show-file-list": false,
      "on-success": _vm.handleDetailUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("\n          建议尺寸375*184，大小≤50KB，优先webp次选png\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "话题名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "不超过100个字符"
    },
    model: {
      value: (_vm.topicForm.title),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "topicForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "摘要",
      "prop": "summary"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "maxlength": 500,
      "placeholder": "不超过500个字符"
    },
    model: {
      value: (_vm.topicForm.summary),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "summary", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "topicForm.summary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类别",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.topicForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.topicForm, "categoryId", $$v)
      },
      expression: "topicForm.categoryId"
    }
  }, _vm._l((_vm.categories), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.topicForm.schObj
    },
    on: {
      "changeVal": _vm.handleSchoolChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1080b174!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/topic/newTopic.vue
// module id = 944
// module chunks = 0